export default "__VITE_ASSET__vRrr0BHB__"